import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import 'react-table/react-table.css';
import { translate } from 'react-i18next';

import { dateFromISO, capitalize } from '../utils/helpers';
import CommonTable from '../components/CommonTable';
import TextFilterField from '../components/filters/TextFilterField';
import DateRangeFilterField from '../components/filters/DateRangeFilterField';
import LoraProviderFilterField from '../components/filters/LoraProviderFilterField';
import * as loraConfigActions from '../redux/modules/loraConfigs';
import i18n from '../translations/i18n';

/*
PropTypes / DefaultProps
 */
const defaultProps = {
  loading: false,
  loraConfigs: {},
};

const propTypes = {
  loading: PropTypes.bool,
  loraConfigs: PropTypes.object,
  fetchLoraConfigs: PropTypes.func,
  t: PropTypes.func,
  currentUser: PropTypes.any,
};

class LoraConfigList extends React.Component {
  /*
    Lifecycle methods
   */
  componentWillMount() {
    this.props.fetchLoraConfigs();
  }

  /*
    Custom methods
   */
  initColumns() {
    this.columns = [
      {
        header: this.props.t('id'),
        accessor: 'id',
        className: 'centerAlign',
        width: 60,
        filterMethod: (filter, row) => parseInt(filter.value, 10) === parseInt(row.id, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="id" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_dev_eui'),
        accessor: 'lora_dev_eui',
        filterMethod: (filter, row) =>
          row.lora_dev_eui.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora_dev_eui" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_app_eui'),
        accessor: 'lora_app_eui',
        filterMethod: (filter, row) =>
          row.lora_app_eui.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora_app_eui" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('lora_app_key'),
        accessor: 'lora_app_key',
        filterMethod: (filter, row) =>
          row.lora_app_key.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="lora_app_key" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: 'LoRa provider',
        accessor: 'lora_provider',
        className: 'centerAlign',
        render: row => row.value !== 'SLS' ? capitalize(row.value) : row.value.toUpperCase(),
        filterRender: ({ filter, onFilterChange }) => (
          <LoraProviderFilterField
            name="lora_provider"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
      },
      {
        header: this.props.t('paketbox_id'),
        accessor: 'paketbox_id',
        className: 'centerAlign',
        filterMethod: (filter, row) => parseInt(filter.value, 10) === parseInt(row.paketbox_id, 10),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="paketbox_id" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('time_created'),
        accessor: 'time_created',
        render: row => (row.value ? dateFromISO(row.value) : ''),
        filterRender: ({ filter, onFilterChange }) => (
          <DateRangeFilterField
            name="time_created"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        filterMethod: (filter, row) => {
          if (!filter.value) return true;
          const startDate = filter.value.startDate.startOf('day');
          const endDate = filter.value.endDate.endOf('day');
          const rowDate = moment(row.time_created);

          return rowDate.isAfter(startDate) && rowDate.isBefore(endDate);
        },
      },
    ];
  }

  fetchData = () => {
    this.props.fetchLoraConfigs();
  };

  itemEdit = (id) => {
    browserHistory.push(`/lora-configs/modify/${id}`);
  };

  itemCreate = () => {
    browserHistory.push('/lora-configs/new');
  };

  render() {
    this.initColumns();

    let data = [];
    if (this.props.loraConfigs) {
      data = Object.values(this.props.loraConfigs);
    }

    const disableCreateNew = !(
      this.props.currentUser && this.props.currentUser.role === 'SUPER_ADMIN'
    );

    const createAction = !disableCreateNew ? this.itemCreate : false;
    return (
      <CommonTable
        title={this.props.t('lora_config_list')}
        data={data}
        onItemEdit={this.itemEdit}
        onItemCreate={createAction}
        loading={this.props.loading}
        columns={this.columns}
        onChange={this.fetchData}
      />
    );
  }
}

LoraConfigList.defaultProps = defaultProps;
LoraConfigList.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.loraConfigs.fetching,
    loraConfigs: state.loraConfigs.entities,
    currentUser: state.auth.current,
  };
}

const extended = translate(['translations'], { i18n })(LoraConfigList);
export default connect(mapStateToProps, loraConfigActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/LoraConfigList.js